import Application from "../../Application";
import Report3Presenter, {
  IReport3Presenter
} from "../../presenter/report/Report3Presenter";
import { IReportService } from "../../service/report/ReportService";
import { INotificationService } from "../../service/notification/NotificationService";

export default class ShowReport3PageInteractor {
  private application: Application;
  private output?: IReport3Presenter;
  private reportService: IReportService;
  private notificationService: INotificationService;

  constructor(application, reportService, notificationService) {
    this.application = application;
    this.reportService = reportService;
    this.notificationService = notificationService;
  }

  async getReportingPeriodList() {
    try {
      return this.reportService.getReportingPeriodList();
    } catch (error) {
      this.notificationService.showError((error as any).message);
    }
  }

  execute() {
    this.output = Report3Presenter({
      application: this.application,
      initialState: {
        reportingPeriodList: [],
        report3CurrentReportingPeriod: undefined,
        report3: undefined,
        report3PeriodFrom: undefined,
        report3PeriodTo: undefined,
        report3Min: undefined,
        report3Max: undefined,
        report3SubmitReason: undefined
      }
    });

    this.getReportingPeriodList().then(
      (reportinPeriodList) =>
        this.output &&
        this.output.loadReportingPeriodList(reportinPeriodList || [])
    );

    return this.output;
  }
}
